import React, { Component } from 'react';
import { Link } from 'react-router';

class Footer extends Component {
  render() {
    return (
      <div className="Footer">
        <div className="background-blue text-contrast">
          <div className="page-container-responsive">
            <div className="row">
              <div className="col-sm-12">
                <div className="space-top-4 space-4 clearfix">
                  <div className="text-mute">
                    &copy; 2017 <Link to="/">Tiny Doorman</Link>.
                  </div>
                  <div className="text-mute">
                  Tiny Doorman is a <u><a href="https://www.locksharp.com">LockSharp Inc</a></u> product.
                  </div>

                  <div className="text-mute">
                    <Link to="/tos">Terms of Service</Link>
                    <span> &middot; </span>
                    <a href="mailto:support@tinydoorman.com" target="_blank">Email Support</a>
                    <span> &middot; </span>
                    <a href="tel:16282275867" target="_blank">+1 (628) 227-5867</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/